/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/**
 * Igračke Plus: flag <html> while the cart drawer is open so third-party
 * launchers (Appstle Loyalty) can be hidden from CSS regardless of their z-index.
 */
(function () {
  var html = document.documentElement;

  function sync() {
    var open = !!document.querySelector('.mini-cart[aria-hidden="false"]');
    html.classList.toggle('cart-drawer-open', open);
  }

  function watch() {
    var miniCart = document.getElementById('mini-cart');
    if (!miniCart || miniCart.dataset.drawerWatched) {
      sync();
      return;
    }
    miniCart.dataset.drawerWatched = 'true';
    new MutationObserver(sync).observe(miniCart, { attributes: true, attributeFilter: ['aria-hidden'] });
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
  document.addEventListener('shopify:section:load', watch);
})();

/**
 * Igračke Plus: delivery estimate (<delivery-estimate> on the product page) and
 * dispatch note (<ship-note> in the cart drawer).
 *
 * Computed in the browser on purpose: Shopify caches rendered pages, so a
 * server-rendered "ships today" would still say that tomorrow. Rules: orders
 * before the cut-off on a working day ship that day, later orders ship the
 * next working day; delivery takes min..max working days after dispatch.
 * Weekends and the configured holidays are skipped. Times are read in
 * Europe/Belgrade so the cut-off is right across DST.
 */
(function () {
  var DAY_MS = 86400000;

  function zonedNow() {
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Belgrade',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date());
    var out = {};
    parts.forEach(function (p) { if (p.type !== 'literal') out[p.type] = Number(p.value); });
    return out;
  }

  function parseHolidays(str) {
    var set = {};
    (str || '').split(',').forEach(function (s) { s = s.trim(); if (s) set[s] = true; });
    return set;
  }

  function isWorkday(ts, holidays) {
    var d = new Date(ts);
    var day = d.getUTCDay();
    if (day === 0 || day === 6) return false;
    return !holidays[d.toISOString().slice(0, 10)];
  }

  function addWorkdays(ts, n, holidays) {
    var t = ts;
    while (n > 0) {
      t += DAY_MS;
      if (isWorkday(t, holidays)) n--;
    }
    return t;
  }

  function estimate(cutoffMinutes, holidays, minDays, maxDays) {
    var now = zonedNow();
    var today = Date.UTC(now.year, now.month - 1, now.day);
    var minutes = now.hour * 60 + now.minute;
    var shipsToday = isWorkday(today, holidays) && minutes < cutoffMinutes;
    var ship = shipsToday ? today : addWorkdays(today, 1, holidays);
    return {
      today: today,
      ship: ship,
      shipsToday: shipsToday,
      minutesLeft: cutoffMinutes - minutes,
      arriveMin: addWorkdays(ship, minDays, holidays),
      arriveMax: addWorkdays(ship, maxDays, holidays)
    };
  }

  function fill(template, vars) {
    return (template || '').replace(/{{\s*(\w+)\s*}}/g, function (_, k) { return vars[k] != null ? vars[k] : ''; });
  }

  function readLists(el) {
    return {
      days: (el.dataset.daysAccusative || '').split(','),
      months: (el.dataset.monthsGenitive || '').split(',')
    };
  }

  function dayName(lists, ts) { return lists.days[new Date(ts).getUTCDay()] || ''; }

  function dateLabel(lists, ts) {
    var d = new Date(ts);
    var month = lists.months[d.getUTCMonth()];
    return month ? d.getUTCDate() + '. ' + month : d.getUTCDate() + '.';
  }

  function countdown(el, minutesLeft) {
    var h = Math.floor(minutesLeft / 60), m = minutesLeft % 60;
    var hu = el.dataset.textHours || 'h', mu = el.dataset.textMinutes || 'min';
    return h > 0 ? h + ' ' + hu + ' ' + m + ' ' + mu : m + ' ' + mu;
  }

  function dispatchText(el, lists, est, withCountdown) {
    if (est.shipsToday) {
      if (withCountdown) return fill(el.dataset.textShipsToday, { time: countdown(el, est.minutesLeft) });
      return el.dataset.textShipsTodayPlain || fill(el.dataset.textShipsToday, { time: countdown(el, est.minutesLeft) });
    }
    if (est.ship === est.today + DAY_MS) return el.dataset.textShipsTomorrow || '';
    return fill(el.dataset.textShipsOnDay, { day: dayName(lists, est.ship) });
  }

  function attach(el, render) {
    render();
    el._deTimer = setInterval(render, 30000);
  }

  function detach(el) {
    clearInterval(el._deTimer);
  }

  /* ---- <delivery-estimate> ---- */
  var DeliveryEstimate = function () { return Reflect.construct(HTMLElement, [], DeliveryEstimate); };
  DeliveryEstimate.prototype = Object.create(HTMLElement.prototype);
  DeliveryEstimate.prototype.constructor = DeliveryEstimate;

  DeliveryEstimate.prototype.connectedCallback = function () {
    var el = this;
    var lists = readLists(el);
    var cutoff = Number(el.dataset.cutoffHour || 13) * 60;
    var holidays = parseHolidays(el.dataset.holidays);
    var minDays = Math.max(1, Number(el.dataset.minDays || 1));
    var maxDays = Math.max(minDays, Number(el.dataset.maxDays || 3));
    var withCountdown = el.dataset.showCountdown !== 'false';
    var availability = {};
    try {
      var raw = el.querySelector('[data-variant-availability]');
      availability = raw ? JSON.parse(raw.textContent) : {};
    } catch (e) { availability = {}; }
    el._available = el.dataset.available === 'true';

    el._onVariant = function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) { el._available = false; }
      else if (Object.prototype.hasOwnProperty.call(availability, String(variant.id))) { el._available = availability[String(variant.id)] === true; }
      else { el._available = !!variant.available; }
      render();
    };
    document.addEventListener('variant:changed', el._onVariant);

    function render() {
      if (!el._available) { el.hidden = true; return; }
      var est = estimate(cutoff, holidays, minDays, maxDays);
      var arrival;
      if (est.arriveMin === est.today + DAY_MS) {
        arrival = fill(el.dataset.textTomorrow, { day: dayName(lists, est.arriveMin) });
      } else {
        arrival = fill(el.dataset.textOnDay, { day: dayName(lists, est.arriveMin), date: dateLabel(lists, est.arriveMin) });
      }
      if (est.arriveMax !== est.arriveMin) {
        arrival += ', ' + fill(el.dataset.textLatest, { day: dayName(lists, est.arriveMax), date: dateLabel(lists, est.arriveMax) });
      }
      el.querySelector('[data-arrival]').textContent = arrival;
      var note = est.shipsToday ? dispatchText(el, lists, est, withCountdown) : (el.dataset.textCutoffHint || dispatchText(el, lists, est, withCountdown));
      el.querySelector('[data-dispatch]').textContent = note;
      el.hidden = false;
    }

    attach(el, render);
  };

  DeliveryEstimate.prototype.disconnectedCallback = function () {
    detach(this);
    document.removeEventListener('variant:changed', this._onVariant);
  };

  if (!customElements.get('delivery-estimate')) customElements.define('delivery-estimate', DeliveryEstimate);

  /* ---- <ship-note> ---- */
  var ShipNote = function () { return Reflect.construct(HTMLElement, [], ShipNote); };
  ShipNote.prototype = Object.create(HTMLElement.prototype);
  ShipNote.prototype.constructor = ShipNote;

  ShipNote.prototype.connectedCallback = function () {
    var el = this;
    var lists = readLists(el);
    var cutoff = Number(el.dataset.cutoffHour || 13) * 60;
    var holidays = parseHolidays(el.dataset.holidays);
    var withCountdown = el.dataset.showCountdown !== 'false';
    attach(el, function () {
      el.textContent = dispatchText(el, lists, estimate(cutoff, holidays, 1, 1), withCountdown);
    });
  };

  ShipNote.prototype.disconnectedCallback = function () { detach(this); };

  if (!customElements.get('ship-note')) customElements.define('ship-note', ShipNote);
})();

/**
 * Igračke Plus: <stock-note> ("In stock · ship note") follows the selected
 * variant. Warehouse only partially re-renders known block types on variant
 * change, so this block tracks availability itself.
 */
(function () {
  var StockNote = function () { return Reflect.construct(HTMLElement, [], StockNote); };
  StockNote.prototype = Object.create(HTMLElement.prototype);
  StockNote.prototype.constructor = StockNote;

  StockNote.prototype.connectedCallback = function () {
    var el = this;
    var availability = {};
    try {
      var raw = el.querySelector('[data-variant-availability]');
      availability = raw ? JSON.parse(raw.textContent) : {};
    } catch (e) { availability = {}; }

    el._onVariant = function (event) {
      var variant = event.detail && event.detail.variant;
      var available;
      if (!variant) available = false;
      else if (Object.prototype.hasOwnProperty.call(availability, String(variant.id))) available = availability[String(variant.id)] === true;
      else available = !!variant.available;
      el.hidden = !available;
    };
    document.addEventListener('variant:changed', el._onVariant);
  };

  StockNote.prototype.disconnectedCallback = function () {
    document.removeEventListener('variant:changed', this._onVariant);
  };

  if (!customElements.get('stock-note')) customElements.define('stock-note', StockNote);
})();

/**
 * Igračke Plus: terms & conditions checkbox before checkout (cart drawer +
 * cart page). The cart forms are novalidate, so we block the checkout submit
 * ourselves. The drawer is re-rendered on every cart change, so the choice
 * is kept in sessionStorage and restored after each render.
 */
(function () {
  var KEY = 'ip-cart-terms-accepted';

  function remembered() {
    try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }

  function remember(value) {
    try { sessionStorage.setItem(KEY, value ? '1' : '0'); } catch (e) {}
  }

  function restore(root) {
    (root || document).querySelectorAll('[data-cart-terms-checkbox]').forEach(function (box) {
      if (remembered()) box.checked = true;
    });
  }

  document.addEventListener('change', function (event) {
    var box = event.target;
    if (!box.matches || !box.matches('[data-cart-terms-checkbox]')) return;
    remember(box.checked);
    var wrap = box.closest('[data-cart-terms]');
    if (box.checked && wrap) {
      wrap.classList.remove('cart-terms--error');
      var err = wrap.querySelector('[data-cart-terms-error]');
      if (err) err.hidden = true;
    }
    // keep drawer and cart page in sync when both are on screen
    document.querySelectorAll('[data-cart-terms-checkbox]').forEach(function (other) {
      if (other !== box) other.checked = box.checked;
    });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    var submitter = event.submitter;
    if (!form.querySelector || !submitter || submitter.name !== 'checkout') return;
    var wrap = form.querySelector('[data-cart-terms]');
    if (!wrap) return;
    var box = wrap.querySelector('[data-cart-terms-checkbox]');
    if (box && !box.checked) {
      event.preventDefault();
      event.stopImmediatePropagation();
      wrap.classList.add('cart-terms--error');
      var err = wrap.querySelector('[data-cart-terms-error]');
      if (err) err.hidden = false;
      box.focus();
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function () { restore(); });
  document.addEventListener('cart:rerendered', function () { restore(); });
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) { restore(); break; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/**
 * Igračke Plus: <sticky-atc> — sticky add-to-cart bar on phones.
 *
 * The bar has no form of its own. Its button forwards the click to the real
 * add-to-cart button, which sits inside <buy-button>; Warehouse's own click
 * handler then serialises the real form (variant + quantity), adds to the cart
 * and opens the drawer. The real button is looked up on every use rather than
 * cached, because Warehouse swaps .product-form__payment-container on each
 * variant change.
 *
 * Price is mirrored from the buy box's .price-list so there is one source of
 * truth for price markup, and the bar is only revealed once the buy box has
 * scrolled out of view upwards.
 */
(function () {
  var LOADING_TIMEOUT = 8000;
  /* Kept in step with the max-width the bar is styled for in custom.css. */
  var PHONE = '(max-width: 640px)';

  var StickyAtc = function () { return Reflect.construct(HTMLElement, [], StickyAtc); };
  StickyAtc.prototype = Object.create(HTMLElement.prototype);
  StickyAtc.prototype.constructor = StickyAtc;

  function realButton(section) {
    return section ? section.querySelector('.product-form__add-button') : null;
  }

  /* The real button reads "DODAJ U KORPU5.354 RSD"; the bar shows the price
     separately, so strip the price span off the label. */
  function labelOf(button) {
    var clone = button.cloneNode(true);
    var price = clone.querySelector('.product-form__add-price');
    if (price) price.parentNode.removeChild(price);
    return clone.textContent.replace(/\s+/g, ' ').trim();
  }

  StickyAtc.prototype.connectedCallback = function () {
    var el = this;
    var section = el.closest('[data-section-type="product"]');
    if (!section) return;

    var button = el.querySelector('[data-sticky-add]');
    var priceBox = el.querySelector('[data-sticky-price]');
    var buyBox = section.querySelector('.product-info__block-item--buy-buttons');
    if (!button || !priceBox || !buyBox) return;

    el._scrolledPast = false;
    el._phone = window.matchMedia(PHONE);

    function sync() {
      var real = realButton(section);
      if (!real) { el._available = false; apply(); return; }

      var source = section.querySelector('.product-form .price-list');
      priceBox.innerHTML = source ? source.innerHTML : '';

      var label = labelOf(real);
      button.textContent = label;
      /* The visible price is aria-hidden, so the button carries the whole
         announcement. Taken from the real button's price span rather than the
         mirrored .price-list, which also holds visually-hidden captions and
         the savings badge. */
      var priceSpan = real.querySelector('.product-form__add-price');
      var price = priceSpan ? priceSpan.textContent.replace(/\s+/g, ' ').trim() : '';
      button.setAttribute('aria-label', price ? label + ' — ' + price : label);

      /* Sold-out and unavailable buttons are rendered outside <buy-button>. */
      el._available = !!real.closest('buy-button');
      button.disabled = !el._available;
      apply();
    }

    function apply() {
      /* CSS already hides the bar above the phone breakpoint; checking it here
         too keeps the hidden attribute honest on desktop. */
      var show = el._scrolledPast && el._phone.matches;
      if (show) {
        el.hidden = false;
        /* Next frame so the transform transition runs from the hidden state. */
        requestAnimationFrame(function () { el.classList.add('is-visible'); });
      } else {
        el.classList.remove('is-visible');
        el.hidden = true;
      }
    }

    /* Read from the buy box's own position rather than an IntersectionObserver.
       An observer only fires on an intersection *change*, so jumping straight
       from "below the fold" to "scrolled past" — an anchor link, restored
       scroll on back-navigation — never fires and the bar stays hidden. */
    function measure() {
      var box = buyBox.getBoundingClientRect();
      /* Only once the buy box has gone past the top of the screen — not while
         it is still below the fold and the customer has yet to see the price. */
      var past = box.bottom < 0;
      if (past !== el._scrolledPast) { el._scrolledPast = past; apply(); }
    }

    el._onScroll = function () {
      if (el._frame) return;
      el._frame = requestAnimationFrame(function () { el._frame = 0; measure(); });
    };
    window.addEventListener('scroll', el._onScroll, { passive: true });
    window.addEventListener('resize', el._onScroll, { passive: true });
    measure();

    function stopLoading() {
      button.classList.remove('is-loading');
      button.disabled = !el._available;
      clearTimeout(el._loadingTimer);
    }

    el._onClick = function () {
      var real = realButton(section);
      if (!real || real.disabled || !real.closest('buy-button')) return;
      button.classList.add('is-loading');
      button.disabled = true;
      /* Warehouse always dispatches product:added, on success and on error,
         but keep a fallback so the bar cannot stay stuck spinning. */
      el._loadingTimer = setTimeout(stopLoading, LOADING_TIMEOUT);
      real.click();
    };
    button.addEventListener('click', el._onClick);

    el._onAdded = stopLoading;
    document.addEventListener('product:added', el._onAdded);

    /* Variant changes swap the payment container and the price markup. */
    el._onVariant = sync;
    document.addEventListener('variant:changed', el._onVariant);

    el._rerenderObserver = new MutationObserver(sync);
    el._rerenderObserver.observe(buyBox, { childList: true, subtree: true });

    /* Rotating a phone can cross the breakpoint in either direction. */
    el._onBreakpoint = apply;
    if (el._phone.addEventListener) el._phone.addEventListener('change', el._onBreakpoint);
    else el._phone.addListener(el._onBreakpoint);

    sync();
  };

  StickyAtc.prototype.disconnectedCallback = function () {
    window.removeEventListener('scroll', this._onScroll);
    window.removeEventListener('resize', this._onScroll);
    if (this._frame) cancelAnimationFrame(this._frame);
    if (this._rerenderObserver) this._rerenderObserver.disconnect();
    clearTimeout(this._loadingTimer);
    document.removeEventListener('product:added', this._onAdded);
    document.removeEventListener('variant:changed', this._onVariant);
    if (this._phone && this._onBreakpoint) {
      if (this._phone.removeEventListener) this._phone.removeEventListener('change', this._onBreakpoint);
      else this._phone.removeListener(this._onBreakpoint);
    }
  };

  if (!customElements.get('sticky-atc')) customElements.define('sticky-atc', StickyAtc);
})();

/**
 * Igračke Plus: product card gallery on collection and search grids.
 *
 * Swiping needs no script: the track is a horizontal scroller with
 * scroll-snap. This adds what CSS cannot: looping arrows, the dots, jumping to
 * the second image while a mouse is over the card (when the theme's "secondary
 * image on hover" setting is on), and hydrating images 3 onwards, which ship
 * inside <template> so a full grid doesn't download every photo up front.
 *
 * Listeners are delegated on document, so cards re-rendered by filtering,
 * sorting or paging work without re-binding.
 */
(function () {
  var GALLERY = '.product-item__gallery';
  var TRACK = 'product-item__gallery-track';
  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

  function trackOf(gallery) {
    return gallery.querySelector('.' + TRACK);
  }

  function galleryAt(target) {
    return target && target.closest ? target.closest(GALLERY) : null;
  }

  function hydrate(gallery) {
    if (gallery._hydrated) return;
    gallery._hydrated = true;
    gallery.querySelectorAll('.product-item__gallery-slide > template').forEach(function (template) {
      template.replaceWith(template.content.cloneNode(true));
    });
  }

  function currentIndex(track) {
    return track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0;
  }

  function goTo(gallery, index, smooth) {
    var track = trackOf(gallery);
    var count = track.children.length;
    index = (index + count) % count;
    track.scrollTo({ left: index * track.clientWidth, behavior: smooth && !REDUCED_MOTION.matches ? 'smooth' : 'auto' });
  }

  function syncDots(gallery) {
    var index = currentIndex(trackOf(gallery));
    gallery.querySelectorAll('.product-item__gallery-dot').forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === index);
    });
  }

  document.addEventListener('click', function (event) {
    var arrow = event.target.closest && event.target.closest('.product-item__gallery-arrow');
    if (!arrow) return;
    var gallery = galleryAt(arrow);
    var step = arrow.classList.contains('product-item__gallery-arrow--prev') ? -1 : 1;
    hydrate(gallery);
    goTo(gallery, currentIndex(trackOf(gallery)) + step, true);
  });

  /* pointerenter/leave don't bubble; over/out with a relatedTarget check give
     the same "crossed the gallery's edge" signal through delegation. */
  function crossed(event) {
    var gallery = galleryAt(event.target);
    return gallery && !gallery.contains(event.relatedTarget) ? gallery : null;
  }

  document.addEventListener('pointerover', function (event) {
    if (event.pointerType !== 'mouse') return;
    var gallery = crossed(event);
    if (!gallery) return;
    hydrate(gallery);
    if (gallery.hasAttribute('data-hover-second') && currentIndex(trackOf(gallery)) === 0) goTo(gallery, 1, false);
  });

  document.addEventListener('pointerout', function (event) {
    if (event.pointerType !== 'mouse') return;
    var gallery = crossed(event);
    if (gallery) goTo(gallery, 0, false);
  });

  /* Touch and keyboard: start loading the rest before the first swipe or
     arrow press lands. */
  ['touchstart', 'focusin'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      var gallery = galleryAt(event.target);
      if (gallery) hydrate(gallery);
    }, { passive: true });
  });

  /* scroll doesn't bubble, hence the capture phase. A trackpad swipe also
     lands here, so it hydrates too. */
  document.addEventListener('scroll', function (event) {
    var track = event.target;
    if (!track.classList || !track.classList.contains(TRACK)) return;
    var gallery = galleryAt(track);
    hydrate(gallery);
    if (gallery._frame) return;
    gallery._frame = requestAnimationFrame(function () {
      gallery._frame = 0;
      syncDots(gallery);
    });
  }, { capture: true, passive: true });
})();

/**
 * Igračke Plus: benefits rotating in the announcement bar.
 *
 * One message shows at a time; the rest are aria-hidden and inert so neither
 * screen readers nor the Tab key reach a message nobody can see. Rotation
 * pauses while the bar is hovered or holds focus, and stops for good once
 * someone uses the arrows or swipes; with reduced motion it never starts.
 */
(function () {
  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');
  var SWIPE_MIN = 40;

  function init(root) {
    if (root._uspReady) return;
    root._uspReady = true;

    var slides = root.querySelectorAll('[data-usp-slide]');
    if (slides.length < 2) return;

    var index = 0;
    var paused = false;
    var stopped = REDUCED_MOTION.matches;
    var interval = (parseInt(root.getAttribute('data-interval'), 10) || 5) * 1000;

    function show(next) {
      index = (next + slides.length) % slides.length;
      for (var i = 0; i < slides.length; i++) {
        var active = i === index;
        slides[i].classList.toggle('is-active', active);
        slides[i].setAttribute('aria-hidden', active ? 'false' : 'true');
        slides[i].toggleAttribute('inert', !active);
      }
    }

    function stepBy(step) {
      stopped = true;
      show(index + step);
    }

    root.addEventListener('click', function (event) {
      var arrow = event.target.closest('[data-usp-step]');
      if (arrow) stepBy(Number(arrow.getAttribute('data-usp-step')));
    });

    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function (event) {
      if (!root.contains(event.relatedTarget)) paused = false;
    });

    var startX = null;
    root.addEventListener('touchstart', function (event) {
      startX = event.touches[0].clientX;
    }, { passive: true });
    root.addEventListener('touchend', function (event) {
      if (startX === null) return;
      var dx = event.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(dx) >= SWIPE_MIN) stepBy(dx < 0 ? 1 : -1);
    }, { passive: true });

    setInterval(function () {
      if (!paused && !stopped && !document.hidden) show(index + 1);
    }, interval);
  }

  function boot() {
    var bars = document.querySelectorAll('[data-announcement-usp]');
    for (var i = 0; i < bars.length; i++) init(bars[i]);
  }

  boot();
  document.addEventListener('shopify:section:load', boot);
})();

/**
 * Igračke Plus: installments popup (snippets/installments-dialog.liquid).
 * Any [data-installments-open] opens it. Esc and the close button are native
 * <dialog>; a click that lands on the <dialog> element itself is a backdrop
 * click, because its inner wrapper covers the whole box.
 */
(function () {
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-installments-open]');
    if (trigger) {
      var dialog = document.getElementById('installments-dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      dialog.showModal();
      return;
    }

    if (event.target.id === 'installments-dialog') event.target.close();
  });
})();
